import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputArticleAttachmentAdd<T extends EMode = EMode.entity> {
  /** Alias: tempFileId */
  tempFileId?: string;
  /** Alias: name */
  name?: string;
  /** Alias: asAttachmentCalculation */
  asAttachmentCalculation?: boolean;
  /** Alias: asAttachmentOffer */
  asAttachmentOffer?: boolean;
  /** Alias: asAttachmentOrderConfirmation */
  asAttachmentOrderConfirmation?: boolean;
  /** Alias: asAttachmentDeliveryNote */
  asAttachmentDeliveryNote?: boolean;
  /** Alias: asAttachmentInvoice */
  asAttachmentInvoice?: boolean;
  /** Alias: asAttachmentDemand */
  asAttachmentDemand?: boolean;
  /** Alias: asAttachmentOrder */
  asAttachmentOrder?: boolean;
  /** Alias: deactivated */
  deactivated?: boolean;
  /** Alias: defaultDocumentToDisplay */
  defaultDocumentToDisplay?: boolean;
  /** Alias: showInShop */
  showInShop?: boolean;

  __typename?: string;
}

const fields: FieldDefinitions<InputArticleAttachmentAdd> = {
  tempFileId: {
    alias: 'tempFileId',
  },
  name: {
    alias: 'name',
  },
  asAttachmentCalculation: {
    alias: 'asAttachmentCalculation',
  },
  asAttachmentOffer: {
    alias: 'asAttachmentOffer',
  },
  asAttachmentOrderConfirmation: {
    alias: 'asAttachmentOrderConfirmation',
  },
  asAttachmentDeliveryNote: {
    alias: 'asAttachmentDeliveryNote',
  },
  asAttachmentInvoice: {
    alias: 'asAttachmentInvoice',
  },
  asAttachmentDemand: {
    alias: 'asAttachmentDemand',
  },
  asAttachmentOrder: {
    alias: 'asAttachmentOrder',
  },
  deactivated: {
    alias: 'deactivated',
  },
  defaultDocumentToDisplay: {
    alias: 'defaultDocumentToDisplay',
  },
  showInShop: {
    alias: 'showInShop',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputArticleAttachmentAddEntityDefinition: EntitiyDefinition<InputArticleAttachmentAdd> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputArticleAttachmentAdd',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
